import getWidgetByName from "../requests";
import { Articles } from "../../articles/entities";
import {prop} from "ramda";

const getArticlesByTypeWidget = (types) =>
  getWidgetByName("article_type_featured_aside_widget", types)
    .then(Articles)
    .then(prop("articles"));

export { getArticlesByTypeWidget };
